import { render, staticRenderFns } from "./FiltersDropdown.vue?vue&type=template&id=4284f6b9&scoped=true&"
import script from "./FiltersDropdown.vue?vue&type=script&lang=js&"
export * from "./FiltersDropdown.vue?vue&type=script&lang=js&"
import style0 from "./FiltersDropdown.vue?vue&type=style&index=0&id=4284f6b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4284f6b9",
  null
  
)

export default component.exports